// const urenv = process.env.NODE_ENV;

// let API_HOST;

// switch (urenv) {
//   case "development":
//     API_HOST = {
//       sso_host: "localhost",
//       basePath: "http://localhost:3000/",
//       //basePath: "https://stage-mysql-myaccount.worktual.co.uk/",
//       apiNodeURL: "https://refactor.worktual.co.uk/commonMyaccount-mysql/v1",
//       apiCcaasURL: "https://stageccaasapi.worktual.co.uk/core_service/v1",
//       //apiNodeURL: "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1",
//       //apiNodeURLSSO: "https://stagemysql-api.worktual.co.uk/urauth/v1",
//       apiServiceUrlUtms: "https://mysqlapi.worktual.co.uk/urutms-mysql/v1",
//       apiNodeECOMPayment: "https://payment.worktual.co.uk.co.uk/payment/v1/ecommpay",
//       appId: 844239,
//       appSecret: "kU9IPc0C65",
//     }
//     break;
//   case "production":
//     API_HOST = {
//       sso_host: ".worktual.co.uk",
//       basePath: "https://stage-mysql-myaccount.worktual.co.uk/",
//       apiNodeURL: "https://refactor.worktual.co.uk/commonMyaccount-mysql/v1",
//       apiCcaasURL: "https://stageccaasapi.worktual.co.uk/core_service/v1",
//       //apiNodeURLSSO: "https://stagemysql-api.worktual.co.uk/urauth/v1",
//       apiNodeECOMPayment: "https://payment.worktual.co.uk.co.uk/payment/v1/ecommpay",
//       // apiNodeURL: "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1",
//       //apiNodeURLSSO: "https://urapi.worktual.co.uk/urauth/v1",
//       apiServiceUrlUtms: "https://mysqlapi.worktual.co.uk/urutms-mysql/v1",
//       appId: 844239,
//       appSecret: 'kU9IPc0C65',
//     }
//     break;
// }
// export { API_HOST };

const urenv = process.env.NODE_ENV;
console.log("urenvurenv", urenv)
let API_HOST;

switch (urenv) {
      case "development":
            API_HOST = {
                  sso_host: "worktual.co.uk",
                  basePath: "https://myaccount.worktual.co.uk/",
                  // basePath: "http://localhost:3000/",
                  apiNodeURL: "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1",
                  apiCcaasURL: "https://ccaasapi.worktual.co.uk/core_service/v1", // qa
                  apiCcaasEmailURL: "https://ccaasapi.worktual.co.uk/emailService/v1", // qa
                  apiCcaasHomeCareURL: "https://carehomeapi.audracare.co.uk/homecare_service/v1",
                  apiSocialmediaServiceURL: "https://ccaasapi.worktual.co.uk/socialmediaService/v1", // qa
                  //apiNodeURL: "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1",
                  apiNodeURLSSO: "https://urapi.worktual.co.uk/urauth/v1",
                  apiServiceUrlUtms: "https://mysqlapi.worktual.co.uk/urutms-mysql/v1",
                  //apiServiceUrlUtms: "https://mysqlapi.worktual.co.uk/qaurutms-mysql/v1",
                  apiNodeECOMPayment: "https://payment.worktual.co.uk/payment/v1/ecommpay",
                  pricingWebsiteURL: "https://qapricing.qaworktual.co.uk",
                  nfsURL: "https://urapi.worktual.co.uk/urcall/v1/file",
                  apiCRMNodeURL: "https://mysqlapi.worktual.co.uk/urcrm-mysql/v1",
                  apiReactURL: "https://urapi.worktual.co.uk/ivr/v1/info",
                  appId: 844239,
                  appSecret: "kU9IPc0C65",
                  API_SERVICE_SSO_V2_URL: "https://urapi.worktual.co.uk/urchat/v2",
                  didNumPurchaseURL: "https://did.worktual.co.uk",
                  API_SERVICE_URL1: "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1",
                  MARKETING_SERVICE: "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1",
                  CCAAS_CONNECTOR_URL: "https://qaccaasapi.worktual.co.uk/connector/common/v1",
                  audraCare_URL :"https://mysqlapi.worktual.co.uk/ws_audracare/",
                  BOOKING_SERVICE:"https://bookingapi.worktual.co.uk/booking_service/v1",
                  TTS_URL:"https://nlp.worktual.co.uk/tts",

            }
            break;
      case "production":
            API_HOST = {
                  sso_host: "worktual.co.uk",
                  basePath: "https://myaccount.worktual.co.uk/",
                  // basePath: "http://localhost:3000/",
                  apiNodeURL: "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1",
                  apiCcaasURL: "https://ccaasapi.worktual.co.uk/core_service/v1",
                  apiCcaasEmailURL: "https://ccaasapi.worktual.co.uk/emailService/v1",
                  apiCcaasHomeCareURL: "https://carehomeapi.audracare.co.uk/homecare_service/v1",
                  apiSocialmediaServiceURL: "https://ccaasapi.worktual.co.uk/socialmediaService/v1", // qa 
                  apiNodeURLSSO: "https://urapi.worktual.co.uk/urauth/v1",
                  apiNodeECOMPayment: "https://payment.worktual.co.uk/payment/v1/ecommpay",
                  apiNodeURL: "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1", //live
                  //apiNodeURLSSO: "https://urapi.worktual.co.uk/urauth/v1" ,
                  // apiServiceUrlUtms: "https://mysqlapi.worktual.co.uk/qaurutms-mysql/v1", 
                  apiServiceUrlUtms: "https://mysqlapi.worktual.co.uk/urutms-mysql/v1",
                  apiNodeECOMPayment: "https://payment.worktual.co.uk/payment/v1/ecommpay",
                  pricingWebsiteURL: "https://pricing.qaworktual.co.uk",
                  nfsURL: "https://urapi.worktual.co.uk/urcall/v1/file",
                  apiReactURL: "https://urapi.worktual.co.uk/ivr/v1/info",
                  apiCRMNodeURL: "https://mysqlapi.worktual.co.uk/urcrm-mysql/v1",
                  appId: 844239,
                  appSecret: 'kU9IPc0C65',
                  API_SERVICE_SSO_V2_URL: "https://urapi.worktual.co.uk/urchat/v2",
                  didNumPurchaseURL: "https://did.worktual.co.uk",
                  API_SERVICE_URL1: "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1",
                  MARKETING_SERVICE: "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1",
                  CCAAS_CONNECTOR_URL: "https://qaccaasapi.worktual.co.uk/connector/common/v1",
                  audraCare_URL :"https://mysqlapi.worktual.co.uk/ws_audracare/",
                  BOOKING_SERVICE:"https://bookingapi.worktual.co.uk/booking_service/v1",
                  TTS_URL:"https://nlp.worktual.co.uk/tts",

            }
            break;
}
export { API_HOST };
